"use strict";

var PropTypes = require("prop-types");

var AccountActions = require("./AccountActions");
var AccountConstants = require("./AccountConstants");
var AccountFormHelper = require("./AccountFormHelper");
var AccountStore = require("./AccountStore");

var SimpleDropdownFromWizard = require("../commonComponents/SimpleDropdownFromWizard");

class AccountPhoneTypeSelector extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			disabled: false,
			selectedPhoneType: props.initialValue || ""
		};

		this._onChange = this._onChange.bind(this);
	}

	handlePhoneTypeSelected(event) {
		if (!event || !event.currentTarget) {
			return;
		}

		var selectedPhoneType = event.currentTarget.value;
		var formParentId = AccountFormHelper.getParentFormId(this);

		AccountActions.setSelectedPhoneType(formParentId, selectedPhoneType);
	}

	_onChange() {
		if (this._isMounted) {
			var $formParent = AccountFormHelper.getParentForm(this);
			var formParentId = AccountFormHelper.getParentFormId(this);

			var parentFormIdForUpdateAllowed = formParentId;
			if ($formParent.length > 0) {
				// updateAllowed applies to this selector when inside the createAccountForm or when inside the eventRegistration component (could be within a createAccountForm or spouseInformation)
				var $parentFormForUpdateAllowed = $formParent.is("[data-component='createAccountForm']") ? $formParent : $formParent.closest("[data-component='eventRegistration']").find("[data-component='createAccountForm']");
				parentFormIdForUpdateAllowed = AccountFormHelper.getParentFormIdFromForm($parentFormForUpdateAllowed);
			}

			this.setState({
				disabled: formParentId ? AccountActions.getIsFormInputDisabled(parentFormIdForUpdateAllowed || formParentId) : false,
				selectedPhoneType: AccountActions.getSelectedPhoneType(formParentId) || ""
			});
		}
	}

	componentDidMount() {
		this._isMounted = true;

		var $formParent = AccountFormHelper.getParentForm(this);
		var formParentId = AccountFormHelper.getParentFormIdFromForm($formParent);
		var updateAllowed = true;

		if ($formParent.length > 0) {
			// updateAllowed applies to this selector when inside the createAccountForm or when inside the eventRegistration component (could be within a createAccountForm or spouseInformation)
			var $parentFormForUpdateAllowed = $formParent.is("[data-component='createAccountForm']") ? $formParent : $formParent.closest("[data-component='eventRegistration']").find("[data-component='createAccountForm']");
			updateAllowed = !$parentFormForUpdateAllowed.length || $parentFormForUpdateAllowed.is("[data-update-allowed]");
		}

		AccountActions.setSelectedPhoneType(formParentId, this.state.selectedPhoneType);
		AccountStore.addSpecificListener(AccountConstants.SET_SELECTED_PHONE_TYPE, this._onChange);
		AccountStore.addChangeListener(this._onChange);
		AccountActions.toggleInputStatus(formParentId, /*disabled*/ !updateAllowed);
	}

	componentWillUnmount() {
		AccountStore.removeChangeListener(this._onChange);
		AccountStore.removeSpecificListener(AccountConstants.SET_SELECTED_PHONE_TYPE, this._onChange);
		if (this.props.isDesignMode) {
			var $formParent = AccountFormHelper.getParentForm(this);
			var formParentId = AccountFormHelper.getParentFormIdFromForm($formParent);
			var updateAllowed = true;

			if ($formParent.length > 0) {
				updateAllowed = $formParent.is("[data-update-allowed]");
			}

			AccountActions.setSelectedPhoneType(formParentId, null);
			AccountActions.toggleInputStatus(formParentId, /*disabled*/ !updateAllowed);
		}

		this._isMounted = false;
	}

	render() {
		return (
			<SimpleDropdownFromWizard
				{...this.props}
				config={this.props.phoneTypeConfig}
				configKey="availablePhoneTypes"
				disabled={this.state.disabled}
				initialValue={this.state.selectedPhoneType}
				optionsClassName="availablePhoneType"
				onChange={this.handlePhoneTypeSelected.bind(this)}
				reactComponentName="AccountPhoneTypeSelector"
				selectClassName="account-phone-type-selector"
				selectNameAttribute="phone.type"
				thisArg={this}
				wizard={AccountStore.get("wizardDefaultPhoneTypes")}
				wizardValuesKey="allowedPhoneTypes"
			/>
		);
	}
}

AccountPhoneTypeSelector.propTypes = {
	isDesignMode: PropTypes.bool,
	phoneTypeConfig: PropTypes.object,
	required: PropTypes.bool,
	theme: PropTypes.string,
	context: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	childClass: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string,
	reactComponentCategory: PropTypes.string
};

module.exports = AccountPhoneTypeSelector;
